import React, {useContext} from 'react';
import {Controller, useFormState} from 'react-hook-form';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import CustomSelect from '@src/components/Fields/CustomSelect';
import classnames from '@src/helpers/classnames';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import getDepartmentsOptions from './getDepartmentsOptions';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import FieldLayout from './extra_row/FieldLayout';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';

export function DepartmentsSelect({rowIndex: index, isDisabled}: { rowIndex: number, isDisabled?: boolean }) {
    const {
        control,
        fieldName,
        modelOptions,
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);
    const {errors} = useFormState({control});

    const options = getDepartmentsOptions(modelOptions ?? {});
    const isInvalid = Boolean(errors.products?.[index]?.department_id);

    return <FieldLayout
            id={null}
            label="OrderForm.products.fields.department"
            className="mb-0"
    >
        <Controller
                control={control}
                name={`${fieldName}.${index}.department_id`}
                render={({field: {name, value, onChange, onBlur}}) => {
                    return <CustomSelect
                            label="OrderForm.products.fields.department"
                            className={classnames({'is-invalid': isInvalid})}
                            name={name}
                            options={options}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            isInvalid={isInvalid}
                            readOnly={options.length < 2 || design.fieldsAreReadOnly || forceReadonly}
                            disabled={isDisabled || design.fieldsAreDisabled || forceDisabled}
                            menuPortalTarget={document.body}
                            clearable
                    />;
                }}
        />
        <FormErrorMessage fieldName={`${fieldName}.${index}.department_id`}/>
    </FieldLayout>;
}
